import React from "react";
import { useLocation } from "react-router-dom";

import ToolLayout from "../ToolLayout";
import ProjectReadinessTool from "./ProjectReadinessTool";
import ProjectReadinessConfig from "./ProjectReadiness.config";

/**
 * ProjectReadinessPage
 *
 * Standalone, SEO-indexable page wrapper for the Project Readiness tool.
 */
const ProjectReadinessPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const category = params.get("category") || undefined;

  return (
    <ToolLayout
      title={ProjectReadinessConfig.title}
      description={ProjectReadinessConfig.description}
    >
      <ProjectReadinessTool category={category} />
    </ToolLayout>
  );
};

export default ProjectReadinessPage;
